interface BucketState {
  tokens: number;
  lastRefillMs: number;
}

export class TokenBucketRateLimiter {
  private readonly capacity: number;
  private readonly refillRatePerSecond: number;
  private state: BucketState;

  constructor(capacity: number, refillRatePerSecond: number) {
    this.capacity = capacity;
    this.refillRatePerSecond = refillRatePerSecond;
    this.state = { tokens: capacity, lastRefillMs: Date.now() };
  }

  consume(cost = 1): boolean {
    this.refill();
    if (this.state.tokens < cost) return false;
    this.state.tokens -= cost;
    return true;
  }

  private refill(): void {
    const now = Date.now();
    const elapsedSeconds = (now - this.state.lastRefillMs) / 1000;
    const refillAmount = elapsedSeconds * this.refillRatePerSecond;
    this.state.tokens = Math.min(this.capacity, this.state.tokens + refillAmount);
    this.state.lastRefillMs = now;
  }
}

